<template>
<ul class="sub-nav" :deep="deep">
  <li
    v-for="nav in subNavList"
    :key="nav.name"
    class="sub-nav-item"
  >
    <sub-nav-item :nav="nav" :deep="deep" />
  </li>
</ul>
</template>

<script>
import BaseStore from '../BaseStore'
import SubNavItem from './SubNavItem'

export default {
  name: 'LayoutSubNav',
  components: {SubNavItem},
  extends: BaseStore,
  props: {
    subNavList: {
      type: Array
    },
    deep: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      visibleNavNames: []
    }
  },
  methods: {
    getHeight (el, visible) {
      let lastChild = el.lastElementChild
      return (lastChild.offsetTop + lastChild.offsetHeight) & (-visible)
    },
    changeHeight (visible) {
      clearTimeout(this.changeHeightTimer)
      let el = this.$el
      el.style.height = `${this.getHeight(el, !visible)}px`

      setTimeout(() => {
        el.style.height = `${this.getHeight(el, visible)}px`

        if (visible) {
          this.changeHeightTimer = setTimeout(() => {
            el.style.height = ''
          }, 300)
        }
      }, 0)
    },
    changeHeightWithoutAnimation (visible) {
      this.$el.style.height = visible ? '' : 0
    }
  }
}
</script>

<style lang="scss" scoped>
.sub-nav {
  position: relative;
  margin: 0;
  padding: 0;

  &[deep="1"] {
    padding: 10px 0;

    > .sub-nav-item {
      line-height: 46px;
    }
  }

  > .sub-nav-item {
    line-height: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/SubNav.vue